import { render, staticRenderFns } from "./SuccessResponseAlert.vue?vue&type=template&id=080820fe&"
import script from "./SuccessResponseAlert.vue?vue&type=script&lang=ts&"
export * from "./SuccessResponseAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports